import { useAuthentication } from '@/components/auth/AuthProvider'
import useSessionStorageUIDotDev from './useSessionStorageUIDotDev'

export default function useSessionStorage<T>(key: string, initialValue: T) {
  const { user } = useAuthentication()
  const fullKey = `${key}-${user?.id || 'logged-out'}`

  return useSessionStorageUIDotDev(fullKey, initialValue)
}
